module.exports = __webpack_public_path__ + "img/logo_alt.eab2bc61.png";